import { Component, OnInit, OnDestroy, ViewChild,ElementRef } from '@angular/core';
import {
    Subject,
    Subscription,
    debounceTime,
    distinctUntilChanged,
} from 'rxjs';
import { IDocument } from '@common/models/Document/IDocument';
import { DatePipe } from '@angular/common';
import { IChat } from '@common/models/Chat/IChat';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { SummaryStatus } from '@common/enums/SummaryStatus';
import { SummaryType } from '@common/enums/SummaryType';
import { IDocumentSummary } from '@common/models/Document/IDocumentSummary';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpStatusCodes } from '@common/enums/HttpStatusCodes';
import { DocumentStatus } from '@common/enums/DocumentStatus';
import { IChatDocument } from '@common/models/Chat/IChatDocument';
import { IChatMetaData } from '@common/models/Chat/IChatMetaData';
import { IAddDoctoChatAPIResp } from '@common/models/Chat/IAddDoctoChatAPIResp';
import { UploadType } from '@common/enums/UploadType';
import { DocumentService } from '@app/services/document.service';
import { ChatServices } from '@app/services/chat.service';
import { ChatType } from '@common/enums/ChatType';
import cloneDeep from 'lodash/cloneDeep';
import { removeDuplicateDocumentsUsingMap } from '@app/utils/removeDuplicateDocumentsUsingMap';
import { getRouteParamChatType } from '@app/utils';

@Component({
    selector: 'app-documents-main',
    templateUrl: './documents-main.component.html',
    styleUrls: ['./documents-main.component.scss'],
    providers: [DatePipe, MessageService, DialogService],
})
export class DocumentsMainComponent implements OnInit, OnDestroy {
    displayedColumns: { header: string; field: string }[] = [
        { header: 'File', field: 'documentName' },
        { header: 'Uploaded By', field: 'creatorName' },
        { header: 'Uploaded At', field: 'createdAt' },
        { header: 'About', field: 'shortSummary' },
        { header: 'Summary', field: 'summaryStatus' },
        { header: 'Actions', field: 'documentStatus' },
    ];
    searchText: string;
    searchTextUpdate = new Subject<any>();
    scrollUpdate = new Subject<any>();
    docLoaders: Object = {}
    docListUpdate = new Subject<string[]>();
    deleteDocListUpdate = new Subject();
    deletingdocsList: IDocument[]=[]
    getAllDocsSub: Subscription = new Subscription();
    uploadSub: Subscription = new Subscription();
    updateChatDocsSub: Subscription = new Subscription();
    createChatSub: Subscription = new Subscription();
    deleteDocSub: Subscription = new Subscription();
    summarySub: Subscription = new Subscription();
    getSummarySub: Subscription = new Subscription();
    isloading: boolean = true;
    files: File[] = [];
    activeChat: IChat;
    dialogMessage: string;
    selectedDocs: IDocument[] = [];
    addingDocLoader: boolean = false;
    addingFolderLoader: boolean = false;

    chatwithDocs: boolean = false;
    docsList: IDocument[] = [];
    displayConfirmationDialog: boolean = false;
    deletingDoc: IDocument;
    deletingDocIndex: number;
    retriggerDoc: IDocument;
    retriggerDocIndex: number;
    docListResponse: IDocument[];
    sidebarVisible: boolean = false;
    summaryData: string = '';
    headerSummary: string;
    dialogType: string;
    showdialog: boolean = false;
    selectedDocForSummary: IDocument;
    destroy$ = new Subject<void>();
    summaryStatusPoll$ = new Subject<void>();
    hasPendingSummary = false;
    activeTabIndex = 0
    ref: DynamicDialogRef | undefined;
    displayDialogType: string;
    documentProcessing: DocumentStatus = DocumentStatus.Processing;
    documentProcessed: DocumentStatus = DocumentStatus.Processed;
    documentArchived: DocumentStatus = DocumentStatus.Archived;
    documentFailed: DocumentStatus = DocumentStatus.Failed;
    summaryCompleted: SummaryStatus = SummaryStatus.Completed;
    summaryProcessing: SummaryStatus = SummaryStatus.Processing;
    summaryFailed: SummaryStatus = SummaryStatus.Failed;
    pageSize: number = 25;
    showLoadMore: boolean = true;
    loadmoreLoading: boolean = false;
    docNameSummary:string;
    longSummaryType:string;
    summaryDocumentName:string
    documentModelForSummary : IDocument;
    uploadDocspageSize:number=0;
    fileTypes=['application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel']
    excelType = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
      ]
      csvType=[
        'text/csv'
      ]
      StructuredType = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'text/csv'
      ]
      nonStructuredType = [
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'text/plain'
      ]
    displayCSVUploadDialog: boolean = false;
    displayExcelInfoDialog: boolean = false;
    CSVFiles: IDocument[] = [];
    excelTables={};
    CSVTablesData : any = []
    @ViewChild('fileUpload') fileUpload: ElementRef;
    @ViewChild('folderUpload') folderUpload: ElementRef;
    expandedFolders: { [key: string]: boolean } = {};

    folderType : UploadType.Folder
    fileType : UploadType.File
    organizedDocsList: IDocument[] = [];

    constructor(
        private readonly docService: DocumentService,
        private readonly chatService: ChatServices,
        private readonly messageService: MessageService,
        private readonly dialogService: DialogService,
        private readonly router: Router
    ) {
        this.searchTextUpdate
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe({
                next: (value) => {
                    if (this.searchText.trim() != '' || (this.searchText.length==0 && value.key=="Backspace")) {
                        this.isloading = true;
                        this.getAllDocs('search');
                    }
                }
            });
        this.docListUpdate
            .pipe(debounceTime(15000), distinctUntilChanged())
            .subscribe({
                next: (value) => {
                    this.getAllDocs('reload');
                }
            });
        this.deleteDocListUpdate
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe({
                next: (value) => {
                    this.getAllDocs('reload');
                }
            });
        this.scrollUpdate
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe({
                next: (value) => {
                    this.scrollLazyLoad(value);
                }
            });
    }
    ngOnInit(): void {
        this.docsList = [];
        this.getAllDocs();
    }


    ngOnDestroy() {
        this.getAllDocsSub?.unsubscribe();
        this.updateChatDocsSub?.unsubscribe();
        this.deleteDocSub?.unsubscribe();
    }



    fileSelect(event: Event, isFolder: boolean = false) {
        event.preventDefault();
        event.stopPropagation();
        const inputElement = event.target as HTMLInputElement;
        if (inputElement.files && inputElement.files.length > 0) {
            let temp_files = Array.from(inputElement.files);

            // Check if the selected folder contains nested folders
            if (isFolder) {
                const hasNestedFolders = temp_files.some(file => file.webkitRelativePath.split('/').length > 2);
                if (hasNestedFolders) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Folder Structure',
                        detail: 'Nested folders are not allowed. Please select a folder without nested folders.',
                    });
                    return;
                }
                if (temp_files.length > 10) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Folder Size Limit',
                        detail: 'Folders with more than 10 files are not allowed. Please select a smaller folder.',
                    });
                    return;
                }
                // Check if the folder contains invalid file types
                const hasInvalidFileType = temp_files.some(file => !this.fileTypes.includes(file.type));
                if (hasInvalidFileType) {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Invalid File Type',
                        detail: 'The folder contains files with unsupported formats. Only .pptx/.docx/.pdf/.txt/.csv/.xlsx/.xls files are allowed.',
                    });
                    return;
                }

                this.files = [...this.files, ...temp_files];
                this.addingFolderLoader = true;
                this.saveFolder();
            } else {
                temp_files.forEach((e: File) => {
                    if (this.fileTypes.includes(e.type)) {
                        this.files = [...this.files, e];
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'File Type',
                            detail: 'Only .pptx/.docx/ .pdf/.txt files are allowed',
                        });
                    }
                });
                if (this.files.length > 0) {
                    this.addingDocLoader = true;
                    this.saveFile();
                }
            }
        }
        if (isFolder) {
            this.folderUpload.nativeElement.value = '';
        } else {
            this.fileUpload.nativeElement.value = '';
        }
    }


    uploadFile(formData: FormData) {
        this.addingDocLoader = true;
        this.docService.uploadFile(formData).subscribe({
            next: (res: IDocument) => {
                this.getAllDocs();
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Document uploaded successfully'
                });
                this.addingDocLoader = false;
            },
            error: (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
                this.addingDocLoader = false;
            }
        });
    }

    uploadFolder(formData: FormData) {
        this.addingDocLoader = true;
        this.docService.uploadFolder(formData).subscribe({
            next: (res: IDocument[]) => {
                this.getAllDocs('uploadFolder');
                this.messageService.add({
                    severity: 'success',
                    summary: 'Folder uploaded successfully'
                });
                this.addingDocLoader = false;
            },
            error: (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
                this.addingDocLoader = false;
            }
        });
    }


    toggleFolder(folderId: string) {
        this.expandedFolders[folderId] = !this.expandedFolders[folderId];
    }



    selectFolder(folder: any) {
        if (folder.type === 'Folder') {
            const folderFiles = folder.files;

            const isFileTypeInList = (fileType: string, typeList: string[]) => typeList.includes(fileType);

            const firstFileType = folderFiles[0]?.contentType;
            const firstFileTypeGroup = this.determineFileTypeGroup(firstFileType, isFileTypeInList);

            if (firstFileTypeGroup) {
                const allSameTypeGroup = folderFiles.every((file: any) =>
                    isFileTypeInList(file.contentType, this[firstFileTypeGroup])
                );

                if (allSameTypeGroup) {
                    folderFiles.forEach((file: any) => {
                        if (this.selectedDocs.length <= 10 && !this.selectedDocs.includes(file)) {
                            this.selectedDocs.push(file);
                        }
                    });
                } else {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Mixed File Types',
                        detail: 'The folder contains mixed file types. Please select files of the same type.',
                    });
                }
            } else {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Unsupported File Types',
                    detail: 'The folder contains unsupported file types. Please select supported file types.',
                });
            }
        }
    }

    private determineFileTypeGroup(fileType: string, isFileTypeInList: (fileType: string, typeList: string[]) => boolean): string | null {
        if (isFileTypeInList(fileType, this.StructuredType)) {
            return 'StructuredType';
        }
        if (isFileTypeInList(fileType, this.nonStructuredType)) {
            return 'nonStructuredType';
        }
        return null;
    }

    deselectFolder(folder: any) {
        if (folder.type === 'Folder') {
            const folderFiles = folder.files;
            folderFiles.forEach((file: any) => {
                const index = this.selectedDocs.indexOf(file);
                if (index >= 0) {
                    this.selectedDocs.splice(index, 1);
                }
            });
        }
    }

    onRowSelect(event: any) {
        if (event.data.type === 'Folder') {
            this.selectFolder(event.data);
        } else {
            this.selectedDocs.push(event.data);
        }
    }

    onRowUnselect(event: any) {
        if (event.data.type === 'Folder') {
            this.deselectFolder(event.data);
        } else {
            const index = this.selectedDocs.indexOf(event.data);
            if (index >= 0) {
                this.selectedDocs.splice(index, 1);
            }
        }
    }

    updateSidebar(value: boolean) {
        this.sidebarVisible = value;
    }
    openSummarySidebar(rowData: IDocument) {
        if (rowData.summaryStatus === SummaryStatus.Completed) {
            rowData['loader'] = true;
            this.getSummarySub.add(
                this.docService.getSummary(rowData.documentId).subscribe({
                    next: (res: IDocumentSummary) => {
                        rowData['loader'] = false;
                        this.dialogType = 'documentSummary';
                        this.sidebarVisible = true;
                        this.summaryData = res.documentSummary;
                        this.longSummaryType = res.summaryType;
                        this.summaryDocumentName = rowData.documentName
                        this.docNameSummary = rowData.documentName
                        this.headerSummary = 'Summary';
                    },
                    error: (error) => {
                        rowData['loader'] = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error.error.message,
                        });
                    },
                })
            );
        }
    }


    emitSummary(selectedSummaryType: SummaryType) {
        this.generateSummary(this.selectedDocForSummary, selectedSummaryType);
        this.showdialog = false;
    }
    closeDialog(value: boolean) {
        this.showdialog = false;
    }
    openDialog(rowData: IDocument) {
      if(rowData?.documentStatus === DocumentStatus.Archived){
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'The summary generation is not possible for this file due to some internal server issues. Please upload the file again to generate the summary. Inconvenience is regretted.',
      });
      }else{
        this.showdialog = true;
        this.selectedDocForSummary = rowData;
      }
    }
    generateSummary(rowData: IDocument, summaryType?: SummaryType) {
        this.summarySub.add(
            this.docService
                .generateSummary(
                    rowData.documentId,
                    summaryType,
                )
                .subscribe({
                    next: (res: IDocumentSummary) => {
                        this.getAllDocs('reload');
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Generating Summary',
                        });
                    },
                    error: (error) => {
                        this.addingDocLoader = false;
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error.error.message,
                        });
                    }
                })
        );
    }


    showAbout(documentModel:IDocument) {
      let aboutText = documentModel.dataDictionary ? JSON.stringify(documentModel.dataDictionary) : documentModel.shortSummary;
      this.dialogType = 'sideBar';
      this.sidebarVisible = true;
      this.summaryData = (aboutText);
      this.summaryDocumentName = documentModel.documentName
      this.documentModelForSummary = documentModel
      this.headerSummary = 'About';
  }

  showDocumentUpdates(documentModel:IDocument){
    this.dialogType = 'sideBar';
    this.sidebarVisible = true;
    this.summaryData = (documentModel.documentRevisions);
    this.summaryDocumentName = documentModel.documentName
    this.documentModelForSummary = documentModel
    this.headerSummary = 'Document Revision';
  }


    truncateSummary(summary: string, maxChars: number): string {
        if (!summary){
          return ''
        }
        summary = this.stripMarkdown(summary)

        if (summary.length <= maxChars) {
            return summary;
        } else {
            const truncatedSummary = summary.substring(0, maxChars) + '...';
            return truncatedSummary;
        }
    }

    saveFile(forceUpload?: boolean) {
        this.addingDocLoader = true;
        this.uploadDocspageSize=this.docsList.length + this.files.length
        this.files.forEach((item: File, i: number): void => {
            const formData = new FormData();
            formData.append('file', this.files[i]);
            if(item.type !== 'application/pdf' ){
                setTimeout(() => {
                    this.getAllDocs('upload')
                }, 2000);
            }
            this.uploadSub.add(
                this.docService.uploadFile(formData, forceUpload).subscribe({
                    next: (res: IDocument) => {
                        this.getAllDocs('upload');
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Document is uploaded successfully',
                        });
                        if (this.files.length - 1 == i) {
                            this.addingDocLoader = false;
                            this.files = [];
                        }
                    },
                    error: (error) => {
                        if (error.status === HttpStatusCodes.Conflict && error.error.message.includes('verify')) {
                            this.displayDialogType = 'verifyUpload';
                            this.dialogMessage = `Another identical file(s) had been detected. Are you sure you still want to upload ?`;
                            this.displayConfirmationDialog = true;
                        } else {
                            this.uploadDocspageSize=this.uploadDocspageSize-1
                            this.messageService.clear();
                            if (error.status === HttpStatusCodes.Conflict) {
                                if(item.type !== 'application/pdf' ){
                                    this.getAllDocs('upload')
                                }
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Error',
                                    detail: 'Another file exist with same name',
                                });
                            } else if(error.status == HttpStatusCodes.ClientError){
                                this.displayExcelInfoDialog = true
                            } else {
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Error',
                                    detail: error.error.message,
                                });
                            }
                            if(item.type !== 'application/pdf' ){
                                this.getAllDocs('upload')
                            }
                            if (this.files.length - 1 == i) {
                                this.addingDocLoader = false;
                                this.files = [];
                            }
                        }
                    }
                })
            );
        });
    }

    saveFolder(forceUpload?: boolean) {
        this.addingFolderLoader = true;
        const formData = new FormData();
        let temprelativepath : any = ''
        this.uploadDocspageSize = this.docsList.length + 15
        this.files.forEach((file: File) => {
            const relativePath = file.webkitRelativePath
            const newFile = new File([file], relativePath, { type: file.type });
            formData.append('files', newFile);
            formData.append('originalname', file.webkitRelativePath)
            temprelativepath = file.webkitRelativePath
        });

        this.docService.uploadFolder(formData, temprelativepath, forceUpload).subscribe({
            next: (res: any) => {
                this.getAllDocs('upload');
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Folder uploaded successfully',
                });
                this.addingFolderLoader = false;
                this.files = [];
            },
            error: (error) => {
                this.addingFolderLoader = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
            }
        });
    }

  shouldDisableSelectALL(): boolean {
    let pdfFiles = 0;
    let structuredDocs = 0;
    let isArchivedFiles = false
     this.docsList.forEach((e:IDocument)=>{
        if(this.excelType.includes(e.contentType) || this.csvType.includes(e.contentType)){
          structuredDocs += 1
        }else{
          pdfFiles += 1
        }
        if(e.documentStatus == DocumentStatus.Archived){
          isArchivedFiles = true
        }
     })
     return (pdfFiles > 0 && structuredDocs > 0 ) || isArchivedFiles
  }

    openRetriggerConfirmation(doc:IDocument,i:number){
        this.displayDialogType = 'retriggerUpload';
        this.dialogMessage = `Are you sure you want to retry the document upload ?`;
        this.displayConfirmationDialog = true;
        this.retriggerDoc=doc
        this.retriggerDocIndex=i
    }


    retriggerUpload(doc:IDocument,i:number){
        this.docsList[i].documentStatus=DocumentStatus.Processing
        this.docService.retriggerUploadFile(doc.documentId).subscribe({
            next:(res:IDocument)=>{
                this.docsList[i]=res
                if(res.documentStatus===DocumentStatus.Processing){
                    this.getAllDocs('reload');
                }
            },
            error:(error)=>{
                this.docsList[i]=doc
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
            }
        })
    }


    ondialogaccept() {
        this.displayConfirmationDialog = false;
        if (this.displayDialogType === 'delete') {
            this.deleteDoc();
        }
        if (this.displayDialogType == 'verifyUpload') {
            this.saveFile(true);
        }
        if (this.displayDialogType == 'retriggerUpload') {
            this.retriggerUpload(this.retriggerDoc,this.retriggerDocIndex);
        }
        if(this.displayDialogType=='deleteSlectedDocs'){
            this.deleteSelectedDocs()
        }
    }


    checkChatDocs() {
        this.chatwithDocs = true;
        this.activeChat = undefined
        this.chatService.updateChatTypeStatus(ChatType.Normal)
        if (this.activeChat == undefined) {
            this.createNewChat();
        } else {
            this.updateChatDocs();
        }
    }


    createNewChat() {
        this.createChatSub = this.chatService.createNewChat().subscribe({
            next: (res: IChat) => {
                void this.handleNewChatCreation(res);
            },
        });
    }

    private async handleNewChatCreation(res: IChat): Promise<void> {
        this.activeChat = res;
        this.getAllDocs('reload');

        this.router.navigate(['/chat', getRouteParamChatType(this.chatService.chatType), this.activeChat.chatId]);
        

        const uniqueDocs = removeDuplicateDocumentsUsingMap(this.selectedDocs);
        this.selectedDocs =  cloneDeep(uniqueDocs)
        this.activeChat.chatDocument = this.selectedDocs;
        let excelCount=0
        this.selectedDocs.forEach((e:IDocument)=>{
            if(this.excelType.includes(e.contentType) || this.csvType.includes(e.contentType)){
            if(this.excelType.includes(e.contentType)){
                excelCount += 1
            }
            this.CSVFiles.push(e)
            }
        })

        if(this.CSVFiles.length == 0 || excelCount == 0){
            this.updateChatDocs();
        }else if(this.CSVFiles.length > 0 && excelCount != 0){
            let showFileUpload = false;
            this.CSVTablesData = {}
            await Promise.all(this.CSVFiles.map(async (csv:IDocument)=>{
            if(this.excelType.includes(csv.contentType)){
                this.CSVTablesData[csv.documentName] = []
                let documentTableMetaData :any = {}
                if(csv.documentMetaData){
                documentTableMetaData = csv.documentMetaData
                }
                else{
                documentTableMetaData = await this.fetchTablesFromExcel(csv.documentId);
                }
                let tableNames = []
                if(Object.keys(documentTableMetaData).length > 0){
                Object.keys(documentTableMetaData).forEach((e:string,i:number)=>{
                    tableNames[i] = {
                        doc : csv,
                        sheet:e,
                        fileName: csv.documentName,
                        tables : documentTableMetaData[e].map((e:any)=>e.tableName),
                        selectedTables : undefined
                        }
                    })
                    this.CSVTablesData[csv.documentName] = tableNames;
                }
            }
            }))
            let showUploadDialog =  false;
            this.CSVFiles.forEach((csv:IDocument)=>{
                if((this.CSVTablesData[csv.documentName]?.length > 1) || 
                    (this.CSVTablesData[csv.documentName]?.length == 1 && this.CSVTablesData[csv.documentName][0]['tables'].length > 1)){
                    showUploadDialog = true
                }
            });
            if(showUploadDialog || showFileUpload){
                showFileUpload = true
                if(showFileUpload){
                    this.displayDialogType = 'CSVUpload'
                    this.displayCSVUploadDialog = true
                }
            }
            else{
                let allDocsData : IChatDocument[]=[]
                this.CSVFiles.forEach((csv:IDocument)=>{
                    let tempmetaData : IChatMetaData[]=[]
                    let tempChatDoc : IChatDocument = {
                    documentId : csv.documentId,
                    documentName : csv.documentName,
                    contentType : csv.contentType,
                    }
                    if(this.CSVTablesData[csv.documentName]){
                        this.CSVTablesData[csv.documentName].map((sheets:any)=>{
                            sheets.tables.map((table:any)=>{
                            let tempTable :IChatMetaData ={
                                sheetName : sheets.sheet,
                                tableName : table
                            }
                            tempmetaData.push(tempTable)
                            })
                        })
                        tempChatDoc['metaData']=tempmetaData
                    }
                    allDocsData.push(tempChatDoc)

                })
                let DocsPayload:IChatDocument[]=[]
                if(this.selectedDocs.length > this.CSVFiles.length){
                    let StructuredDocsIdentifiers = new Set(allDocsData.map(doc => `${doc.documentId}-${doc.documentName}`));
                    let uniqueDocs = new Set<string>();
                    this.selectedDocs.forEach((e: IDocument) => {
                        if (e.type !== UploadType.Folder) {
                            let uniqueIdentifier = `${e.documentId}-${e.documentName}`;
                            if (!StructuredDocsIdentifiers.has(uniqueIdentifier) && !uniqueDocs.has(uniqueIdentifier)) {
                                uniqueDocs.add(uniqueIdentifier);
                                DocsPayload.push({
                                    documentId: e.documentId,
                                    documentName: e.documentName,
                                    contentType: e.contentType
                                });
                            }
                        }
                    });
                }
                this.attachChatstoDocs([...allDocsData,...DocsPayload])
            }
        }
    }

    private fetchTablesFromExcel(documentId: string): Promise<any> {
      return new Promise<any>((resolve, reject) => {
        this.docService.getTablesFromExcel(documentId).subscribe({
          next: (res: any) => {
            resolve(res || {});
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    }

    submitFileUploadDialog(excelDocs:IChatDocument[]){
      this.chatwithDocs = true
      let DocsPayload:IChatDocument[]=[]
      let StructuredDocsIdentifiers = new Set(excelDocs.map(doc => `${doc.documentId}-${doc.documentName}`));
      let uniqueDocs = new Set<string>();
      this.selectedDocs.forEach((e: IDocument) => {
          if (e.type !== UploadType.Folder) {
              let uniqueIdentifier = `${e.documentId}-${e.documentName}`;
              if (!StructuredDocsIdentifiers.has(uniqueIdentifier) && !uniqueDocs.has(uniqueIdentifier)) {
                  uniqueDocs.add(uniqueIdentifier);
                  DocsPayload.push({
                      documentId: e.documentId,
                      documentName: e.documentName,
                      contentType: e.contentType
                  });
              }
          }
      });
      this.attachChatstoDocs([...excelDocs,...DocsPayload])
    }

    attachChatstoDocs(chatDocs:IChatDocument[]){
      this.updateChatDocsSub.add(
          this.chatService
              .updateChatDocuments(
                  chatDocs,
                  this.activeChat.chatId
              )
              .subscribe({
                  next: (res) => {
                      this.activeChat = res?.data;
                      this.chatService.updateActiveChatObs(res?.data);
                      this.chatService.updateActiveChat(res?.data);
                      if(res?.message?.trim() != ''){
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: res?.message,
                        });
                      }
                  },
                  error: (error) => {
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: error.error.message,
                      });
                  },
              })
      );
  }

    updateChatDocs() {
        let DocsPayload:IChatDocument[]=[]
        let uniqueDocs = new Set<string>();
        this.selectedDocs.forEach((e: IDocument) => {
            if (e.type !== UploadType.Folder) {
                let uniqueIdentifier = `${e.documentId}-${e.documentName}`;
                if (!uniqueDocs.has(uniqueIdentifier)) {
                    uniqueDocs.add(uniqueIdentifier);
                    DocsPayload.push({
                        documentId: e.documentId,
                        documentName: e.documentName,
                        contentType: e.contentType
                    });
                }
            }
        });
        this.updateChatDocsSub.add(
            this.docService
                .updateChatDocuments(DocsPayload, this.activeChat.chatId)
                .subscribe({
                    next: (res: IAddDoctoChatAPIResp) => {
                        this.activeChat = res?.data;
                        this.chatwithDocs = false;
                        this.chatService.updateActiveChatObs(this.activeChat);
                        this.chatService.updateActiveChat(this.activeChat);
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Chat documents updated successfully',
                        });
                        if(res?.message?.trim() != ''){
                          this.messageService.add({
                              severity: 'error',
                              summary: 'Error',
                              detail: res?.message,
                          });
                        }
                    },
                    error: (error) => {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error.error.message,
                        });
                    },
                })
        );
    }

    getButtonClass(rowData: IDocument) {
      if (rowData.summaryStatus) {
          if (rowData.summaryStatus === SummaryStatus.Processing) {
              return 'btn-processing';
          } else if (rowData.summaryStatus === SummaryStatus.Completed) {
              return 'btn-completed';
          } else if (rowData.summaryStatus === SummaryStatus.Failed) {
              return 'btn-failed';
          } else {
              return 'btn-new';
          }
      } else {
          return 'btn-new';
      }
  }


  getDocStatusClass(rowData: IDocument) {
      if (rowData.documentStatus) {
          if (rowData.documentStatus === DocumentStatus.Processing) {
              return 'chip-processing';
          } else if (rowData.documentStatus === DocumentStatus.Processed) {
              return 'chip-completed';
          } else if (rowData.documentStatus === DocumentStatus.Failed) {
              return 'chip-failed';
          } else if (rowData.documentStatus === DocumentStatus.Archived) {
            return 'chip-archive';
        } else {
              return 'chip-new';
          }
      } else {
          return 'chip-new';
      }
  }


  getInitials(name: string): string {
      const nameArray = name.trim().split(' ');
      const initials = nameArray
          .map((word) => word.charAt(0))
          .join('')
          .toUpperCase();


      return initials;
  }


  showSummary(summaryStatus: SummaryStatus): boolean {
      return summaryStatus === SummaryStatus.Completed;
  }
  showProcessingSummary(summaryStatus: SummaryStatus): boolean {
      return summaryStatus === SummaryStatus.Processing;
  }
  showFailedSummary(summaryStatus: SummaryStatus): boolean {
      return summaryStatus === SummaryStatus.Failed;
  }
  showNewSummary(summaryStatus: SummaryStatus): boolean {
      return summaryStatus === SummaryStatus.New;
  }



    deleteConfirmationDialog(element: IDocument, i: number) {
        this.displayDialogType = 'delete';
        this.dialogMessage = `Are you sure you want to delete ${element.documentName} ?`;
        this.displayConfirmationDialog = true;
        this.deletingDoc = element;
        this.deletingDocIndex = i;
    }


    deleteSelectedConfirmationDialog() {
        this.displayDialogType = 'deleteSlectedDocs';
        this.dialogMessage = `Are you sure you want to delete selected documents ?`;
        this.displayConfirmationDialog = true;
    }


    onCancelDialog() {
        this.displayConfirmationDialog = false;
        if (this.displayDialogType == 'verifyUpload') {
            this.addingDocLoader = false;
            this.uploadDocspageSize=this.uploadDocspageSize-1
        }
    }

    closeInFoSlider(event: boolean) {
      this.displayExcelInfoDialog = false;
    }


    deleteDoc() {
        this.displayConfirmationDialog = false;
        let deletingDoc = this.deletingDoc
        this.docLoaders[deletingDoc.documentId] = {}
        this.docLoaders[deletingDoc.documentId]['deleteLoader'] = true
        this.deleteDocSub.add(
            this.docService.deleteDoc(this.deletingDoc.documentId,this.deletingDoc.documentName).subscribe({
                next: (res) => {
                    this.getAllDocs('reload');
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Deleted',
                        detail: 'Document is successfully deleted',
                    });
                },
                error: (error) => {
                    this.docLoaders[deletingDoc.documentId]['deleteLoader'] = false
                    this.getAllDocs('reload');
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            })
        );
    }




    deleteSelectedDocs() {

        // Helper function to remove duplicates
        const removeDuplicates = (docs: IDocument[]): IDocument[] => {
            const uniqueDocs: { [key: string]: IDocument } = {};
            docs.forEach(doc => {
                uniqueDocs[doc.documentId] = doc;
            });
            return Object.values(uniqueDocs);
        };

        // Remove duplicates from selectedDocs
        const uniqueSelectedDocs = removeDuplicates(this.selectedDocs);

        this.displayConfirmationDialog = false;
        uniqueSelectedDocs.forEach((ele: IDocument, i: any) => {
            this.deletingdocsList.push(ele);
            this.isloading = true;

            if (ele.type === 'Folder') {
                // Delete the folder and its contents with a single API call
                this.deleteDocSub.add(
                    this.docService.deleteDoc(ele.documentId, ele.documentName).subscribe({
                        next: (res) => {
                            this.deletingdocsList = this.deletingdocsList.filter(e => e.documentId !== ele.documentId);
                            this.deleteDocListUpdate.next(ele.documentId);
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Deleted',
                                detail: 'Folder and its contents are successfully deleted',
                            });
                        },
                        error: (error) => {
                            this.deletingdocsList = this.deletingdocsList.filter(e => e.documentId !== ele.documentId);
                            this.deleteDocListUpdate.next(ele.documentId);
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error.error.message,
                            });
                        },
                    })
                );
            } else {
                // Delete individual documents
                this.deleteDocSub.add(
                    this.docService.deleteDoc(ele.documentId, ele.documentName).subscribe({
                        next: (res) => {
                            this.deletingdocsList = this.deletingdocsList.filter(e => e.documentId !== ele.documentId);
                            this.deleteDocListUpdate.next(ele.documentId);
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Deleted',
                                detail: 'Document is successfully deleted',
                            });
                        },
                        error: (error) => {
                            this.deletingdocsList = this.deletingdocsList.filter(e => e.documentId !== ele.documentId);
                            this.deleteDocListUpdate.next(ele.documentId);
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error.error.message,
                            });
                        },
                    })
                );
            }

            if (uniqueSelectedDocs.length === i + 1) {
                this.selectedDocs = [];
            }
        });
    }




    getAllDocs(type?: string,pageSize?:any) {
        if(pageSize){
            this.pageSize  = pageSize
        }
        else{
            this.pageSize = 25
        }
        this.showLoadMore = true;
        let tempSelectedDocs=this.selectedDocs
        let params = {
            pageSize: this.pageSize,
        };
        if (type == 'loadmore') {
            this.loadmoreLoading = true;
            params['loadMore']=true
            params['markerId'] = this.docsList.at(-1)['_id'];

        }
        if (type == 'search') {
            (params['search'] = this.searchText);
        }
        if (type == 'reload') {
            params.pageSize = this.docsList.length;
            if (this.searchText?.trim()!='') {
                (params['search'] = this.searchText);
            }
        }
        if (type == 'upload') {
            params.pageSize = this.uploadDocspageSize;
        }
        if(type == 'uploadFolder'){
            params.pageSize = this.pageSize;
        }
        this.getAllDocsSub.add(
            this.docService.getAllDocs(params).subscribe({
                next: (response: IDocument[]) => {
                    if (response?.length && (response.at(-1)['inFolder'] === true || response.at(-1).type === 'Folder')){
                        this.docsList = [...cloneDeep(response)]
                        this.organizeDocuments();
                        this.getAllDocs('loadmore')
                    }
                    else{
                        this.loadmoreLoading = false;

                        if (type == 'reload' || type == 'search' || type == 'upload') {
                            this.docsList = [...cloneDeep(response)]
                            this.organizeDocuments();

                        } else {
                            this.docsList = [...cloneDeep(this.docsList), ...cloneDeep(response)];
                            this.organizeDocumentsLoadMore(cloneDeep(response))

                        }
                         if (this.deletingdocsList.length == 0) {
                            this.isloading = false
                        }
                        if (response.length < this.pageSize) {
                            this.showLoadMore = false;
                        }


                        let checkInprogress = [];


                        this.docsList.forEach((doc: IDocument) => {
                            if (
                                (doc.summaryStatus &&
                                    doc.summaryStatus ===
                                    SummaryStatus.Processing) ||
                                doc.documentStatus === DocumentStatus.Processing || doc.documentStatus === DocumentStatus.Converting || doc.documentRevisionsStatus === SummaryStatus.Processing
                            ) {
                                checkInprogress.push(doc.documentId);
                            }
                        });
                        if (checkInprogress.length > 0) {
                            this.docListUpdate.next(checkInprogress);
                        }
                        this.selectedDocs = []
                        if (tempSelectedDocs?.length > 0 && this.docsList.length > 0) {
                            tempSelectedDocs?.map((e: IDocument) => {
                                const foundItem = this.docsList.find(
                                    (chatDocs: IDocument) =>
                                        chatDocs.documentId === e.documentId
                                );
                                if (foundItem) {
                                    this.selectedDocs.push(foundItem);
                                }
                            });
                        }
                    }

                },
                error: (error) => {
                    this.loadmoreLoading = false;
                    this.isloading = false;
                },
            })
        );
    }
    organizeDocuments() {
        const folders: any = this.docsList.filter(doc => doc.type === 'Folder');
        const files = this.docsList.filter(doc => doc.type === 'file' && !folders.some(folder => folder.files.includes(doc.documentId)));

        folders.forEach(folder => {
            folder['files'] = this.docsList.filter(doc => folder.files.includes(doc.documentId));
        });
        this.organizedDocsList = [...folders, ...files];

    }
    organizeDocumentsLoadMore(response: any){
        const folders: any = (response.filter(doc => doc.type === 'Folder'));
        const files = response.filter(doc => doc.type === 'file' && !folders.some(folder => folder.files.includes(doc.documentId)));

        folders.forEach(folder => {
            folder['files'] = response.filter(doc => folder.files.includes(doc.documentId));
        });
        this.organizedDocsList = [...this.organizedDocsList,...folders, ...files];
    }

    scrollLazyLoad(event) {
        let scrollHeightArr = [];
        let shMin = event.target.scrollHeight - 5;
        let shMax = event.target.scrollHeight + 5;
        for (let i = shMin; i < shMax; i++) {
            scrollHeightArr.push(i);
        }
        if (
            scrollHeightArr.includes(
                Math.ceil(event.target.offsetHeight + event.target.scrollTop)
            ) &&
            this.showLoadMore
        ) {
            this.getAllDocs('loadmore');
        }
    }

    downloadFile(doc: IDocument, i: number) {
        this.docService.downloadFile(doc.documentId).subscribe({
            next: (res) => {
                const data = res['data'];
                const uint8Array = new Uint8Array(data['data']);
                const blob = new Blob([uint8Array], { type: 'application/pdf' });
                const url = globalThis.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = doc.documentName;
                document.body.appendChild(a);
                a.click();
                delete this.docsList[i]['downloadLoader'];
            }
        });
    }

    generateDocUpdates(rowData: IDocument,i:number) {
      this.organizedDocsList[i].documentRevisionsStatus = SummaryStatus.Processing
      this.summarySub.add(
          this.docService
              .generateDocUpdates(
                  rowData.documentId,
              )
              .subscribe({
                  next: (res: IDocumentSummary) => {
                      this.getAllDocs('reload');
                      this.messageService.add({
                          severity: 'success',
                          summary: 'Success',
                          detail: 'Generating Document Revisions',
                      });
                  },
                  error: (error) => {
                      this.addingDocLoader = false;
                      this.messageService.clear();
                      this.messageService.add({
                          severity: 'error',
                          summary: 'Error',
                          detail: error.error.message,
                      });
                  }
              })
      );
  }

  stripMarkdown(markdown: string): string {
    // Replace headers
    markdown = markdown.replaceAll(/(^|\s)(#+)\s+(.*)/g, '$3');

    // Replace bold and italic
    markdown = markdown.replaceAll(/(\*\*|__)(.*?)\1/g, '$2'); // bold
    markdown = markdown.replaceAll(/[*_](.*?)[*_]/g, '$1');   // italic

    // Replace links and images
    markdown = markdown.replaceAll(/\[([^\]]+)\]\([^)]+\)/g, '$1'); // links
    markdown = markdown.replaceAll(/!\[([^\]]*)\]\([^)]+\)/g, '$1'); // images

    // Replace inline code and code blocks
    markdown = markdown.replaceAll(/`{3}[^`]*`{3}/g, ''); // code blocks
    markdown = markdown.replaceAll(/`([^`]*)`/g, '$1'); // inline code

    // Replace blockquotes
    markdown = markdown.replaceAll(/^\s{0,3}>\s?/gm, '');

    // Replace unordered lists
    markdown = markdown.replaceAll(/^\s*[-*+]\s+/gm, '');

    // Replace ordered lists
    markdown = markdown.replaceAll(/^\s*\d+\.\s+/gm, '');

    // Replace horizontal rules
    markdown = markdown.replaceAll(/^-{3,}/gm, '');

    // Remove any remaining HTML tags
    markdown = markdown.replaceAll(/<\/?[^>]+(>|$)/g, '');

    // Replace line breaks
    markdown = markdown.replaceAll(/\n{2,}/g, '\n').trim();

    return markdown;
  }

}
